module.exports = __webpack_public_path__ + "static/Wing-288d6107bc5e41f0948ac8b6943d72af.jpg";